import { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  message?: string;
  action?: ReactNode;
}

function EmptyState({ icon, title, message, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-zt-border bg-zt-surface px-6 py-12 text-center">
      <div className="text-zt-muted">{icon ?? <Inbox size={32} />}</div>
      <div>
        <p className="text-sm font-medium text-slate-200">{title}</p>
        {message && <p className="mt-1 text-sm text-zt-muted">{message}</p>}
      </div>
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}

export default EmptyState;
